import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CallCenterVolunteer } from "../call-center-volunteer";
import { Organization } from "../organization";
import { OrganizationManager } from "../organization-manager";
import { CallCenterChatMessageEntityConfig } from "./config";
import { CallCenterChatMessageFilters } from "./filters";
import { CallCenterChatMessageMethods } from "./methods";

export const CALL_CENTER_CHAT_MESSAGE_KINDS = [
  "TEXT",
  "DETAILS_CARD",
  "INCOMING_CALL",
  "SYSTEM",
] as const;

export type CallCenterChatMessageKind =
  (typeof CALL_CENTER_CHAT_MESSAGE_KINDS)[number];

@HyperEntity<CallCenterChatMessage>(
  "call-center-chat-message",
  CallCenterChatMessageEntityConfig,
)
export class CallCenterChatMessage extends extender(
  CallCenterChatMessageFilters,
  CallCenterChatMessageMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "volunteer_id", caption: "מתנדב" })
  volunteerId = "";

  @Relations.toOne(() => CallCenterVolunteer, "volunteerId")
  volunteer?: CallCenterVolunteer;

  @Fields.string({ dbName: "organization_id", caption: "ארגון" })
  organizationId = "";

  @Relations.toOne(() => Organization, "organizationId")
  organization?: Organization;

  @Fields.string({
    dbName: "sender_manager_id",
    allowNull: true,
    caption: "שולח",
  })
  senderManagerId?: string;

  @Relations.toOne(() => OrganizationManager, "senderManagerId")
  senderManager?: OrganizationManager;

  @Fields.literal(() => CALL_CENTER_CHAT_MESSAGE_KINDS, { caption: "סוג" })
  kind: CallCenterChatMessageKind = "TEXT";

  @Fields.string({ caption: "תוכן" })
  body = "";

  @Fields.json({ allowNull: true, caption: "מטען" })
  payload?: Record<string, unknown>;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();
}
